<h4>Canvas</h4>
<ul>

    <li>Besoin identifié: {{ canvas()['need'] }}</li>
    <li>Cible: {{ canvas()['target'] }}</li>
    <li>Parties prenantes: {{ canvas()['stakeholders'] }}</li>
    <li>Place de l’IA: {{ canvas()['aiPlace'] }}</li>
    <li>Proposition de valeur unique: {{ canvas()['uniqueValue'] }}</li>
    <li>Freins potentiels: {{ canvas()['obstacles'] }}</li>

</ul>

